module.exports = __webpack_public_path__ + "static/media/motorcyk_verified.e9507868.svg";